import type { PluginManifest } from './types';

/** Route shape from legacy top-level `routes` or `contributions.routes`. */
export interface PluginManifestRoute {
  path: string;
  component: string;
  title?: string | null;
  resource?: string;
  action?: string;
  hidden?: boolean;
  public?: boolean;
  op_ref_id?: string;
  resource_id?: string;
  authorization?: { op_ref_id?: string; resource_id?: string };
  nav_group?: string;
  nav_label?: string;
  nav_icon?: string;
  nav_order?: number;
}

type LegacyManifest = PluginManifest & { routes?: PluginManifestRoute[] };

/**
 * Map legacy top-level `routes` into `contributions.routes` for the shell.
 * Also flattens nested `authorization` objects onto each route.
 */
export function normalizePluginManifest(manifest: PluginManifest): PluginManifest {
  const existing = manifest.contributions?.routes;
  if (Array.isArray(existing) && existing.length > 0) {
    return manifest;
  }

  const legacy = (manifest as LegacyManifest).routes;
  if (!Array.isArray(legacy) || legacy.length === 0) {
    return manifest;
  }

  const normalized: PluginManifestRoute[] = legacy.map((raw) => {
    const route: PluginManifestRoute = { ...raw };
    const authz = route.authorization;
    if (authz && typeof authz === 'object') {
      if (authz.op_ref_id && !route.op_ref_id) {
        route.op_ref_id = authz.op_ref_id;
      }
      if (authz.resource_id && !route.resource_id) {
        route.resource_id = authz.resource_id;
      }
      delete route.authorization;
    }
    if (route.op_ref_id) {
      if (!route.resource) route.resource = 'plugin.route';
      if (!route.action) route.action = 'view';
    }
    return route;
  });

  return {
    ...manifest,
    contributions: {
      ...manifest.contributions,
      routes: normalized,
    },
  };
}
